module.exports = __webpack_public_path__ + "img/waf-d.0c01c5d.svg";